const svgElement = document.getElementById("bg");
const xmlns = "http://www.w3.org/2000/svg";
let bgCustomize = document; // = document.getElementById("svg_bg--customize");
let timeOutFunctionId;

let larm = 36; // dynamic
let sarm = larm / 3; // dynamic(*)
let gap = 0; // dynamic
let stroke = 2; // dynamic
let isColoured = false; // dynamic
let defaultStrokeColour = "rgba(0,8,24,0.1)"; // dynamic?
/*
const colours inicials = [
  "rgba(38, 70, 83, 1)",
  "rgba(42, 157, 143, 1)",
  "rgba(233, 196, 106, 1)",
  "rgba(244, 162, 97, 1)",
  "rgba(231, 111, 81, 1)",
]*/
const colours = ["#005C53", "#9FC131", "#DBF237", "#D6D58E", "#042940"];
let pos_x_initial = larm;
let pos_y_initial = larm;
let animationDurationMin = 3; // 1-6
let animationDurationGap = 1;
let animationRepeat = 0; // 0-6

function createThreePiece(index, cx, cy) {
  let group = document.createElementNS(xmlns, "g");
  group.setAttribute("id", `group${index}`);
  group.setAttribute("class", "three-pieces");
  group.appendChild(createPiece(index, cx, cy, "left"));
  group.appendChild(createPiece(index, cx + 0, cy + sarm, "left"));
  group.appendChild(createPiece(index, cx + 0, cy + 2 * sarm, "left"));
  group.appendChild(createPiece(index, cx, cy, "right"));
  group.appendChild(createPiece(index, cx + sarm, cy - sarm / 2, "right"));
  group.appendChild(createPiece(index, cx + 2 * sarm, cy - sarm, "right"));
  group.appendChild(createPiece(index, cx, cy, "top"));
  group.appendChild(createPiece(index, cx - sarm, cy - sarm / 2, "top"));
  group.appendChild(createPiece(index, cx - 2 * sarm, cy - sarm, "top"));
  svgElement.appendChild(group);
}

function createPiece(index, cx, cy, face) {
  let colour = colours[Math.floor(Math.random() * colours.length)];
  let duration = Math.random() * animationDurationGap + animationDurationMin;
  duration = parseFloat(duration.toFixed(1));
  let repeat = Math.floor(Math.random() * animationRepeat) + 1;
  const s = larm / 3;
  const l = larm / 2;
  const pieceClass = isColoured ? "piece" : "piece--bn";
  let points = "0,0 0,0";
  switch (face) {
    case "left":
      points = `${cx},${cy} ${cx - 2 * l},${cy - l}
        ${cx - 2 * l},${cy - l + s} ${cx},${cy + s}`;
      break;
    case "right":
      points = `${cx},${cy} ${cx + s},${cy - s / 2}
        ${cx + s},${cy + 2 * l - s / 2} ${cx},${cy + 2 * l}`;
      break;
    case "top":
      points = `${cx},${cy} ${cx + 2 * l},${cy - l}
        ${cx + 2 * l - s},${cy - l - s / 2} ${cx - s},${cy - s / 2}`;
      break;
    default:
      console.log(`Sorry, there is no ${face}.`);
  }
  let faced = document.createElementNS(xmlns, "polygon");
  faced.setAttribute("id", `facex${face}x${index}`);
  faced.setAttribute("class", pieceClass);
  faced.setAttribute("points", points);
  faced.setAttribute("fill", colour);
  faced.setAttribute("fill-opacity", 0);
  faced.setAttribute("stroke", defaultStrokeColour);
  faced.setAttribute("stroke-width", stroke);
  faced.setAttribute("stroke-linejoin", "round");
  if (isColoured) {
    let animation = document.createElementNS(xmlns, "animate");
    animation.setAttribute("attributeName", "fill-opacity");
    animation.setAttribute("values", "0;1;1;0.8");
    animation.setAttribute("dur", `${duration}s`);
    animation.setAttribute("begin", `group${index}.mouseover`);
    animation.setAttribute("repeatCount", repeat);
    faced.appendChild(animation);
  }
  return faced;
}

/* Empty SVG elements */
function emptySVG() {
  var children = Array.prototype.slice.call(svgElement.childNodes);
  children.forEach(function (child) {
    svgElement.removeChild(child);
  });
}

/* Generate SVG elements */
function createSVG() {
  let pos_x = pos_x_initial;
  let pos_y = pos_y_initial / 2;
  const nombre_cw = Math.floor(window.innerWidth / (larm * 2 + gap)) + 1;
  const nombre_ch = Math.floor(window.innerHeight / (larm * 1.5 + gap)) + 1;

  emptySVG();

  for (let j = 0; j < nombre_ch; j++) {
    pos_x = pos_x_initial - (j % 2) * larm;
    for (let i = 0; i < nombre_cw; i++) {
      createThreePiece(i + "x" + j, pos_x, pos_y);
      pos_x += larm * 2 + gap;
    }
    pos_y += larm * 1.5 + gap;
  }
}

function setAttributes(el, attrs) {
  Object.keys(attrs).forEach((key) => el.setAttribute(key, attrs[key]));
}

function createSvgBgConfig() {
  bgCustomize = document.createElement("div");
  bgCustomize.id = "svg_bg--customize";
  bgCustomize.className = "scf-hidden";

  var label_colour = document.createElement("label");
  setAttributes(label_colour, { for: "colour" });
  label_colour.innerHTML = "colour? <em id='colour-display'>no</em>";
  var input_colour = document.createElement("input");
  setAttributes(input_colour, {
    type: "checkbox",
    id: "colour",
    className: "colour",
    name: "colour",
    value: false,
  });

  var label_side = document.createElement("label");
  setAttributes(label_side, { for: "side" });
  label_side.innerHTML = "side <em id='side-display'>36px</em>";
  var input_side = document.createElement("input");
  setAttributes(input_side, {
    type: "range",
    id: "side",
    className: "slider",
    name: "side",
    min: 12,
    max: 240,
    value: 36,
    step: 12,
  });

  var label_gap = document.createElement("label");
  setAttributes(label_gap, { for: "gap" });
  label_gap.innerHTML = "gap <em id='gap-display'>0px</em>";
  var input_gap = document.createElement("input");
  setAttributes(input_gap, {
    type: "range",
    id: "gap",
    className: "slider",
    name: "gap",
    min: 0,
    max: 240,
    value: 0,
    step: 2,
  });

  var label_stroke = document.createElement("label");
  setAttributes(label_stroke, { for: "stroke" });
  label_stroke.innerHTML = "stroke <em id='stroke-display'>1px</em>";
  var input_stroke = document.createElement("input");
  setAttributes(input_stroke, {
    type: "range",
    id: "stroke",
    className: "slider",
    name: "stroke",
    min: 0,
    max: 24,
    value: 1,
    step: 1,
  });

  bgCustomize.appendChild(label_colour);
  bgCustomize.appendChild(input_colour);
  bgCustomize.appendChild(label_side);
  bgCustomize.appendChild(input_side);
  bgCustomize.appendChild(label_gap);
  bgCustomize.appendChild(input_gap);
  bgCustomize.appendChild(label_stroke);
  bgCustomize.appendChild(input_stroke);
  document.body.appendChild(bgCustomize);
}

function updateBgSettingsForm() {
  const sliders = bgCustomize.querySelectorAll("input");
  for (const slide of sliders) {
    switch (slide.id) {
      case "colour": {
        slide.checked = isColoured;
        break;
      }
      case "side": {
        slide.value = larm;
        bgCustomize.querySelector("#side-display").innerText = `${larm}px`;
        break;
      }
      case "gap": {
        slide.value = gap;
        bgCustomize.querySelector("#gap-display").innerText = `${gap}px`;
        break;
      }
      case "stroke": {
        slide.value = gap;
        bgCustomize.querySelector("#stroke-display").innerText = `${stroke}px`;
        break;
      }
      default: {
        break;
      }
    }
  }
}

function changeBgSettings() {
  const sliders = bgCustomize.querySelectorAll("input");
  for (const slide of sliders) {
    slide.addEventListener(
      "input",
      (event) => {
        const property = event.target.id;
        let newValue;
        if (property === "colour") {
          newValue = event.target.checked === true;
        } else {
          newValue = event.target.value;
        }

        switch (property) {
          case "side": {
            if (larm !== newValue) {
              larm = parseInt(newValue, 10);
              sarm = larm / 3;
              pos_x_initial = larm;
              pos_y_initial = larm;
              bgCustomize.querySelector(
                "#side-display"
              ).innerText = `${larm}px`;
              createSVG();
            }
            break;
          }
          case "gap": {
            if (gap !== newValue) {
              gap = parseInt(newValue, 10);
              bgCustomize.querySelector("#gap-display").innerText = `${gap}px`;
              createSVG();
            }
            break;
          }
          case "stroke": {
            if (stroke !== newValue) {
              stroke = parseInt(newValue, 10);
              bgCustomize.querySelector(
                "#stroke-display"
              ).innerText = `${stroke}px`;
              createSVG();
            }
            break;
          }
          case "colour": {
            if (isColoured !== newValue) {
              console.log(isColoured, newValue);
              isColoured = newValue;
              bgCustomize.querySelector("#colour-display").innerText = `${
                isColoured ? "yes" : "no"
              }`;
              createSVG();
            }
            break;
          }
          default: {
            break;
          }
        }
      },
      false
    );
  }
}

function listenToEasterEgg() {
  document.addEventListener("easteregg::show", () => {
    document.getElementById("svg_bg--customize").classList.remove("scf-hidden");
  });
  document.addEventListener("easteregg::hide", () => {
    document.getElementById("svg_bg--customize").classList.add("scf-hidden");
  });
}
/* Events */
window.addEventListener("resize", function () {
  clearTimeout(timeOutFunctionId);
  timeOutFunctionId = setTimeout(createSVG, 2000);
});

/* Init */
createSVG();
createSvgBgConfig();
changeBgSettings();
updateBgSettingsForm();
listenToEasterEgg();
